import React from "react";
import {useLocation} from "react-router-dom";
import {ErrorBoundary} from "./ErrorBoundary";

export default function GlobalBoundary({ children }: { children: React.ReactNode }) {
    const location = useLocation();
    return (
        <ErrorBoundary location={location}>
            {children}
        </ErrorBoundary>
    );
}